import { savedOrderListPaginationStyles } from "@insite/content-library/Widgets/SavedOrderList/SavedOrderListPagination";
import { css } from "styled-components";

savedOrderListPaginationStyles.pagination = {
    cssOverrides: {
        pagination: css`
            margin: 16px 0px 104px 0px !important;
        `,
    },
};
